@if (!collapsed) {
  <form>
    <div class="mt-1">Select providers who work at this office location that match the consult note specialty</div>
    <div class="row mt-1">
      <div class="col-8">
        <div><strong>Prescribers at this office</strong></div>
        <div class="small">
          <strong>OFFICE FAX:</strong>
          @if (patientAttachment.associatedProviderOffice) {
            <app-office-fax
              [office]="patientAttachment.associatedProviderOffice.office" />
          }
          @if (patientAttachment.multipleSpecialtiesAtAssociatedOffice) {
            <span class="multispecialty">(multispecialty)</span>
          }
        </div>
        <div class="small">
          <strong>OFFICE NAME:</strong> {{ officeNames | joinList }}
        </div>
      </div>
      <div class="col-4 text-end">
        <button class="btn btn-sm btn-secondary py-1" (click)="onRefreshClick()">
          <fa-icon [icon]="['fas', 'redo']" class="check" /> REFRESH
        </button>
      </div>
    </div>
    @if (!patientAttachment.hasMatchingSpecialtyPmvs) {
      <div class="bg-danger-subtle text-danger-emphasis p-2 my-1 mx-0 row">
        <div class="col-auto gx-1">
          <fa-icon [icon]="['fas', 'exclamation-triangle']" />
        </div>
        <div class="col">
          Selected provider(s) do not match consult note specialty.
          Update the provider specialty or deselect the provider to proceed with verification.
        </div>
      </div>
    }
    @if (patientAttachment.includesOtherOfficePrescribers) {
      <div class="bg-warning-subtle text-warning-emphasis p-2 my-1 mx-0 row">
        <div class="col-auto gx-1">
          <fa-icon [icon]="['fas', 'exclamation-triangle']" />
        </div>
        <div class="col">
          Provider(s) outside of the office have been identified on the note.
          Please confirm if the providers should be added to the office prior to submission.
        </div>
      </div>
    }
    @if (!refreshing) {
      <div class="prescribers border p-1">
        <div class="mt-2"><strong>Prescribers at this office with scripts for patient</strong></div>
        @if (providersWithPrescriptions.length > 0) {
          <div class="mb-1">
            <app-validate-prescriber-match-verifications
              (verificationChange)="onPrescriberVerificationChange($event)"
              [prescriberMatchOptions]="providersWithPrescriptions"
              />
          </div>
        } @else {
          <div class="ps-3"><small>No Prescribers Found</small></div>
        }
        <hr />
        <div class="mt-2"><strong>Prescribers at this office without scripts for patient</strong></div>
        @if (providersWithoutPrescriptions.length > 0) {
          <div class="mb-1">
            <app-validate-prescriber-match-verifications
              (verificationChange)="onPrescriberVerificationChange($event)"
              [prescriberMatchOptions]="providersWithoutPrescriptions"
              />
          </div>
        } @else {
          <div class="ps-3"><small>No Prescribers Found</small></div>
        }
      </div>
      <div class="mt-1">
        @if (!hideNotes) {
          <app-additional-details-input
            id="prescriberMatchNotes"
            [frozen]="notesFrozen"
            [value]="patientAttachment.prescriberMatchVerificationNotes"
            (valueChange)="onAdditionalTextChange($event)"
            />
        }
      </div>
      <div class="mt-2"><strong>Prescribers at other offices with scripts for patient</strong></div>
      <div class="prescribers border p-1">
        @if (providersAtOtherOfficesWithPrescriptions.length > 0) {
          <div>
            @for (provider of providersAtOtherOfficesWithPrescriptions; track provider) {
              <div class="my-2 ps-3">
                <app-provider [provider]="provider" />
              </div>
            }
          </div>
        } @else {
          <div class="ps-3"><small>No Prescribers Found</small></div>
        }
      </div>
    } @else {
      <mat-spinner diameter="30" />
    }
  </form>
}
@if (collapsed) {
  @if (allSelectedProviderOptions.length > 0) {
    @for (prescriberMatchOption of allSelectedProviderOptions; track prescriberMatchOption) {
      <div>
        <strong>{{ prescriberMatchOption.name }}</strong> ({{ prescriberMatchOption.specialty }})
      </div>
    }
  } @else {
    <div>No Prescribers Selected</div>
  }
}
